module.exports = __webpack_public_path__ + "img/send-icon.67dfe0a5.png";